export var UnrealisedFXGainOrLossType;
(function (UnrealisedFXGainOrLossType) {
    UnrealisedFXGainOrLossType["FXGainOrLoss"] = "FXGainOrLoss";
    UnrealisedFXGainOrLossType["FXUnwind"] = "FXUnwind";
})(UnrealisedFXGainOrLossType || (UnrealisedFXGainOrLossType = {}));
export var UnrealisedFXGainOrLossSubType;
(function (UnrealisedFXGainOrLossSubType) {
    UnrealisedFXGainOrLossSubType["FXGainPayable"] = "FXGainPayable";
    UnrealisedFXGainOrLossSubType["FXLossPayable"] = "FXLossPayable";
    UnrealisedFXGainOrLossSubType["FXGainReceivable"] = "FXGainReceivable";
    UnrealisedFXGainOrLossSubType["FXLossReceivable"] = "FXLossReceivable";
})(UnrealisedFXGainOrLossSubType || (UnrealisedFXGainOrLossSubType = {}));
export const UnrealisedFXGainOrLossActionTypeLabels = {
    [UnrealisedFXGainOrLossType.FXGainOrLoss]: 'Unrealised FX Gain/Loss',
};
//# sourceMappingURL=index.js.map